import {
  AdditionalWorkingStepDto,
  CopyWorkingStepArgs,
  ResourceWorkingStepManualDiscountArgs,
  ResourceWorkingStepManualSurchargeArgs,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import {
  IWorkingStepsAPI,
  WorkingStepsController,
} from '../../../controllers/WorkingStepsController'
import { FormDataDto } from '../../../model/FormDataDto'
import { OnRequestChangeCallback } from '../BaseAPI'
import { WorkingStepDto, WorkingStepsDto } from './internal-api.contracts'
import { InternalAPI } from './InternalAPI'

export class WorkingStepsAPI extends InternalAPI implements IWorkingStepsAPI {
  constructor(
    organizationId: string,
    private onRequestChange: OnRequestChangeCallback
  ) {
    super()
    this.baseAddress += `/api/parties/${organizationId}/projects`
  }

  async GetWorkingSteps(projectId: string, rowId: string) {
    return await this.GetAsync<WorkingStepsDto>({
      id: WorkingStepsController.WorkingStepsOperations.LOAD_DATA,
      relativePath: `/${projectId}/items/${rowId}/workingsteps`,
      onRequestChange: this.onRequestChange,
    })
  }

  async SaveWorkingStepForm(
    projectId: string,
    rowIds: string[],
    workingStepDto: WorkingStepDto,
    formData: FormDataDto
  ) {
    return await this.PostAsync<void>({
      relativePath: `/${projectId}/workingsteps`,
      data: {
        itemIds: rowIds,
        formData,
        workingStepDto,
      },
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id: WorkingStepsController.WorkingStepsOperations.SAVE_DATA,
        })
      },
    })
  }

  public async DeleteWorkingSteps(
    projectId: string,
    rowIds: string[],
    primaryWorkingStepsToDelete: WorkingStepType[]
  ) {
    return await this.PostAsync<void>({
      id: WorkingStepsController.WorkingStepsOperations.DELETE_DATA,
      relativePath: `/${projectId}/workingsteps/delete`,
      data: {
        itemIds: rowIds,
        primaryWorkingStepsToDelete,
      },
      onRequestChange: this.onRequestChange,
    })
  }

  async DeleteAdditionalWorkingStep(
    projectId: string,
    rowIds: string[],
    workingStepDto: WorkingStepDto
  ) {
    return await this.PostAsync<void>({
      relativePath: `/${projectId}/workingsteps/delete`,
      data: {
        itemIds: rowIds,
        primaryWorkingStep: workingStepDto.primaryWorkingStep,
      },
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id:
            WorkingStepsController.WorkingStepsOperations.DELETE_DATA +
            `_${workingStepDto.key}`,
        })
      },
    })
  }

  async GetWorkingStepForm(
    projectId: string,
    bomItemId: string,
    workingStepType: WorkingStepType
  ) {
    return await this.GetAsync<AdditionalWorkingStepDto>({
      relativePath: `/${projectId}/items/${bomItemId}/forms`,
      params: {
        primaryWorkingStep: workingStepType,
      },
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id: WorkingStepsController.WorkingStepsOperations.GET_FORM,
        })
      },
    })
  }

  async SetWorkingStepManualDiscount(
    projectId: string,
    workingStepType: WorkingStepType,
    args: ResourceWorkingStepManualDiscountArgs
  ) {
    return await this.PutAsync<void>({
      id: `SetWorkingStepManualDiscount-${workingStepType}`,
      relativePath: `/${projectId}/workingsteps/${workingStepType}/discount`,
      data: args,
      onRequestChange: this.onRequestChange,
    })
  }

  async SetWorkingStepManualSurcharge(
    projectId: string,
    workingStepType: WorkingStepType,
    args: ResourceWorkingStepManualSurchargeArgs
  ) {
    return await this.PutAsync<void>({
      id: `SetWorkingStepManualSurcharge-${workingStepType}`,
      relativePath: `/${projectId}/workingsteps/${workingStepType}/surcharge`,
      data: args,
      onRequestChange: this.onRequestChange,
    })
  }

  async DeleteWorkingStepManualDiscount(
    projectId: string,
    workingStepType: WorkingStepType
  ) {
    return await this.DeleteAsync({
      id: `DeleteWorkingStepManualDiscount-${workingStepType}`,
      relativePath: `/${projectId}/workingsteps/${workingStepType}/discount`,
      onRequestChange: this.onRequestChange,
    })
  }

  async DeleteWorkingStepManualSurcharge(
    projectId: string,
    workingStepType: WorkingStepType
  ) {
    return await this.DeleteAsync({
      id: `DeleteWorkingStepManualSurcharge-${workingStepType}`,
      relativePath: `/${projectId}/workingsteps/${workingStepType}/surcharge`,
      onRequestChange: this.onRequestChange,
    })
  }

  async CopyWorkingStepsToOtherParts(
    projectId: string,
    args: CopyWorkingStepArgs
  ) {
    return await this.PostAsync<void>({
      id: `CopyWorkingStepsToOtherParts`,
      relativePath: `/${projectId}/workingsteps/CopyWorkingStep`,
      data: args,
      onRequestChange: this.onRequestChange,
    })
  }
}
